import { Box, Flex, Stack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { Tabs } from '@chakra-ui/react';
import Password from './Password';
import AccountInformation from './AccountInformation';
import Team from './Team';
import { fetchAPI } from '@/api/fetch';
import { apiGetAccountProfile } from '@/api/services';

export default function Profile() {
  const [account, setAccount] = useState<Account | null>(null);
  const [tab, setTab] = useState('profile');

  useEffect(() => {
    const fetchAccount = async () => {
      try {
        const response = await fetchAPI<Account>({
          request: apiGetAccountProfile
        });
        if (response.success) {
          setAccount(response.data);
        }
      } catch (error) {
        console.error('Error fetching account:', error);
      }
    };

    fetchAccount();
  }, []);

  return (
    <Flex direction="column" w="100%" bg="background.primary" p="40px 48px">
      <Box mb="40px">
        <Box
          bg="background.secondary"
          border="1px solid"
          borderColor="neutrals.200"
          borderRadius="12px"
          p="24px"
          mb="40px"
        >
          <Stack>
            <Tabs.Root value={tab} onValueChange={(e) => setTab(e.value)} colorPalette="blue">
              <Tabs.List mb="12px">
                {['profile', 'team', 'password'].map((value) => (
                  <Tabs.Trigger key={value} value={value} asChild>
                    <Box fontSize="18px" color={tab === value ? 'primary.1000' : 'neutrals.900'}>
                      {value.charAt(0).toUpperCase() + value.slice(1)}
                    </Box>
                  </Tabs.Trigger>
                ))}
              </Tabs.List>
              <Tabs.Content value="profile">
                <AccountInformation
                  key="updateProfileForm"
                  account={account}
                  setAccount={setAccount}
                />
              </Tabs.Content>
              <Tabs.Content value="team">
                <Team key="teamManagement" account={account} />
              </Tabs.Content>
              <Tabs.Content value="password">
                <Password key="updatePasswordForm" />
              </Tabs.Content>
            </Tabs.Root>
          </Stack>
        </Box>
      </Box>
    </Flex>
  );
}
